import React from 'react'
import { Progress } from 'semantic-ui-react'

export default class Range extends React.Component {
    
    handleContainerRef = (container) => {
        this.container = container
    }

    getOffset(el) {
        var _x = 0
        while( el && !isNaN( el.offsetLeft ) && !isNaN( el.offsetTop ) ) {
            _x += el.offsetLeft - el.scrollLeft
            el = el.offsetParent
        }
        return _x
    }

    dispatchValue(pageX) {
        const { container } = this
        if (!container)
            return
        const { maxValue, onChange } = this.props

        const x = pageX - this.getOffset(container)
        const value = Math.max(0, Math.min(x * maxValue / (container?container.offsetWidth:maxValue), maxValue))
        if (isNaN(value) || value === this.props.value)
            return

        onChange(value)
    }

    handleThumbMouseMove = (ev) => {
        ev.preventDefault()
        this.dispatchValue(ev.pageX || (ev.touches && ev.touches[0] && ev.touches[0].pageX))
    }

    handleThumbMouseUp = () => {
        window.removeEventListener('mousemove', this.handleThumbMouseMove)
        window.removeEventListener('touchmove', this.handleThumbMouseMove)
        window.removeEventListener('mouseup', this.handleThumbMouseUp)
        window.removeEventListener('thouchend', this.handleThumbMouseUp)
    }

    handleThumbMouseDown = (ev) => {
        window.addEventListener('mousemove', this.handleThumbMouseMove, { passive: false })
        window.addEventListener('touchmove', this.handleThumbMouseMove, { passive: false })
        window.addEventListener('mouseup', this.handleThumbMouseUp)
        window.addEventListener('touchend', this.handleThumbMouseUp)
        ev.preventDefault()

        this.dispatchValue(ev.pageX || (ev.touches && ev.touches[0] && ev.touches[0].pageX))
    }

    render() {
        const { maxValue, value, ...rest } = this.props
        return (
            <div className='range' ref={this.handleContainerRef} onMouseDown={this.handleThumbMouseDown} onTouchStart={this.handleThumbMouseDown}>
                <Progress total={maxValue} value={value} color='yellow' {...rest} />
                <div className='range-thumb' style={{
                    left: Math.min(value / maxValue * 100, 100) + '%',
                }}></div>
            </div>
        )
    }
} 


// WEBPACK FOOTER //
// ./src/components/Range.js